// @flow
import { createReducer } from 'actions';
import type { ZuzuAction } from 'types';

import { LOAD_APPOINTMENTS } from 'actions/appointments';
import { LOGOUT } from 'actions/auth';
import type {
  AppointmentType,
  LoadAppointmentsAction,
} from 'actions/appointments';

type State = {
  all: Array<AppointmentType>,
  error: ?string,
};

const initialState: State = {
  all: [],
  error: null,
};

export default createReducer(
  initialState,
  {
    [LOAD_APPOINTMENTS]: (state: State, action: LoadAppointmentsAction) => {
      if (action.meta.done && !action.meta.error && action.payload) {
        return {
          ...state,
          all: [...action.payload],
          error: null,
        };
      }
      return state;
    },

    [LOGOUT]: () => {
      return { ...initialState };
    },
  },
  (state: State, action: ZuzuAction) => {
    return {
      ...state,
      error: action.payload,
    };
  }
);



// WEBPACK FOOTER //
// ./src/redux/reducers/appointments.js